import { en, type MessageKey } from './en';
import { zhCN } from './zh-CN';

export type Locale = 'en' | 'zh-CN';
export type TranslationParams = Record<string, string | number>;

const dictionaries: Record<Locale, Record<MessageKey, string>> = {
  en,
  'zh-CN': zhCN,
};

export function translate(locale: Locale, key: MessageKey, params: TranslationParams = {}): string {
  const template = dictionaries[locale][key] ?? en[key];
  return Object.entries(params).reduce(
    (message, [name, value]) => message.replaceAll(`{${name}}`, String(value)),
    template,
  );
}

export function getInitialLocale(): Locale {
  const saved = localStorage.getItem('truealpha-locale');
  return saved === 'zh-CN' ? 'zh-CN' : 'en';
}

export function setDocumentLocale(locale: Locale): void {
  document.documentElement.lang = locale === 'zh-CN' ? 'zh-CN' : 'en';
  document.title =
    locale === 'zh-CN'
      ? 'TrueAlpha | 本地 PNG 透明度检测工具'
      : 'TrueAlpha | Local PNG Transparency Inspector';
  localStorage.setItem('truealpha-locale', locale);
}

export type { MessageKey };
